import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n/I18nContext";
import SectionHead from "../components/SectionHead";

const ease = [0.16, 1, 0.3, 1];

export default function Bridge() {
  const { t } = useI18n();
  return (
    <section
      id="transition"
      className="section border-t hair"
      data-testid="bridge-section"
    >
      <div className="container-edge">
        <SectionHead
          kana={t.sections.transition.kana}
          roman={t.sections.transition.roman}
        />

        <motion.a
          href="https://www.xn--stto-l3a.com"
          target="_blank"
          rel="noopener noreferrer"
          className="object-card grid grid-cols-12 items-start gap-4 md:gap-10"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          data-testid="bridge-to-sotto-btn"
        >
          {/* numeric mark */}
          <div className="col-span-3 md:col-span-2">
            <span className="mono" style={{ color: "var(--faded)" }}>obj. 01</span>
          </div>

          {/* name + copy */}
          <div className="col-span-9 md:col-span-7">
            <h3 className="display text-[44px] md:text-[72px] lg:text-[92px] mb-6" style={{ fontWeight: 400 }}>
              {t.transition.heading}
            </h3>
            <p className="body-text mb-6" style={{ maxWidth: "44ch" }}>
              {t.transition.copy}
            </p>
            <p className="mono" style={{ color: "var(--faded)" }}>
              {t.transition.micro}
            </p>
          </div>

          {/* cta */}
          <div className="col-span-12 md:col-span-3 md:col-start-10 flex md:justify-end items-start mt-4 md:mt-2">
            <span className="mono-md under-link" style={{ color: "var(--ink)" }}>
              {t.transition.cta}  →
            </span>
          </div>
        </motion.a>
      </div>
    </section>
  );
}
